import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {BehaviorSubject, of} from 'rxjs';
import {AuthguardServiceService} from './authguard-service.service';
import {RoleService} from './roles.service';
import {ROLES} from '../model/roles.model';
import {UrlConstants} from '../constants/url-constants';
import {ApiService} from './api.service';
import {Constants} from '../constants/ebtq-constants';

declare let window: any;
declare let sessionStorage: any;
declare let localStorage: any;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  // save host name that initially we came from
  public hostname = window.location.hostname;
  // Current authentication status
  public isAuthenticated = new BehaviorSubject(false);
  env: any;
  apiGeeLocalData = {
    userDetails: {  firstName: 'Eboutique',
      lastName: 'Test User',
      middleInitial: '',
      fmFederationID: 'E1005291',
      mail: 'pundarika_x_challala@fanniemae.com',
      telephoneNumber: '7038332814',
      sub: 'w1b6911t',
      uid: 'w1b6911t',
      department: '',
      division: '',
      employeeNumber: '',
      employeeType: '',
      fmCostCenter: '',
      fmManagerLevel: '',
      fmbusinessunit: '',
      isInternalUser: true,
      location: '',
      streetAddress: '',
      title: '',
      isExternalUser: false,
      subscriberName: 'Eboutique Test External Subscriber',
      userType: 'EU',
      corporateFamilyCode: '',
      institutionIdDefault: '2073',
      institutionNameDefault: 'JAMES B. NUTTER AND COMPANY',
      mornetID: '',
      mornetParntSubscrberId: '242643',
      primaryKeySubcriberId: '242643',
      sellerServicerCoNo: '',
      subscriberMplusId: 'w1b69g',
      ultimateParntSubscrberId: '242643',
      groups: [
        'SG-GJU-ENVIRONMENT-EBOUTIQUE-AWS-Admin'
      ],
      emailAddress: 'pundarika_x_challala@fanniemae.com',
      workNumber: '7038332814',
      mobileNumber: '7038332814',
      username: 'c2eu3pnc',
      isFannieMaeUser: '',
      dealerOrgName: 'Eboutique Test External Subscriber',
      institutionId: '2073',
      customerName: 'JAMES B. NUTTER AND COMPANY',
      dealerOrgId: '242643',
      mornetPlusId: 'w1b69g',
      parentId: '242643',
      state: 'VA',
      postalCode: '20120',
      fax: '',
      city: 'Herndon'
    }
  };
  private roleData: ROLES[] = [];
  isUserExternal = false;

  role = 'role';
  DEVELOPER_UPDATE = 'Developer';
  ADMIN_UPDATE = 'Admin';

  RM_INTERNAL_VIEW = 'RMInternalView';
  RM_INTERNAL_UPDATE = 'RMInternalUpdate';

  RM_EXTERNAL_SERVICING_VIEW = 'ServicingExternalView';
  RM_EXTERNAL_SERVICING_UPDATE = 'ServicingExternalUpdate';

  RM_EXTERNAL_DELIVERY_UPDATE = 'DeliveryExternalUpdate';
  RM_EXTERNAL_DELIVERY_VIEW = 'DeliveryExternalView';

  constructor(private service: ApiService, private authService: AuthguardServiceService, private roleService: RoleService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const url: string = state.url;
    sessionStorage.setItem('isAPIGEE', 'true');
    return this.checkApigeeLogin(url, route.data.roles, route.data.accessiblity);
  }

  // APIGEE login
  public checkApigeeLogin(url: string, reqRoles: string[],  accessiblity: string): boolean {

    // to Clear any data stored in local storage
    localStorage.clear();
    const isAccessible = (accessiblity === 'delivery') ? sessionStorage.getItem('DeliverySystemIndicator') :
      (accessiblity === 'servicing') ? sessionStorage.getItem('ServicingSystemIndicator') : 'true' ;
    let isAuthorized = false;
    if (this.isAuthenticated.value ) {
      if (reqRoles !== undefined && reqRoles.length > 0) {
        const userRoles = JSON.parse(sessionStorage.getItem('roles'));
        for (const reqRole of reqRoles) {
          for (let i = 0; i < userRoles.length; i++) {
            if (reqRole.replace(/\b(?:DEVL|TEST|ACPT|PROD)\b/gi, 'ENVIRONMENT')
                === userRoles[i].replace(/\b(?:DEVL|TEST|ACPT|PROD)\b/gi, 'ENVIRONMENT') && isAccessible === 'true' ) {
              isAuthorized =  true;
            }
          }
        }
        return isAuthorized;
      }
      else
      {
        return true;
      }
    }

    this.service.redirectUrl = null;

    // Store the attempted URL for redirecting
    // In some cases URL is coming as '/', Ex. when user click logout
    if (url && url.length > 1) {
      this.service.redirectUrl = url;
    } else {
      // In case of empty route, redirect to home page
      this.service.redirectUrl = '/mainMenu';
    }

    if (this.hostname === 'localhost') {

      sessionStorage.setItem('roles', JSON.stringify(this.apiGeeLocalData.userDetails.groups));
      let isAuth = false;
      isAuth = this.setApigeeRoleAuthentication(this.apiGeeLocalData.userDetails);
      /** Request Seller and Serviver from RAMAPI */
      this.callRAMSellerServNumber(this.apiGeeLocalData.userDetails);
      // debugger;
      if (isAuth) {
        this.handleAppRedirect();
      }
      this.isAuthenticated.next(true);
      sessionStorage.setItem('userID', this.apiGeeLocalData.userDetails.uid);
      this.authService.setAuthFlag();
      return isAuth;
    }
    return this.Authenticate();
  }


  Authenticate(): boolean {

    const requestUrl = 'https://' + this.hostname + UrlConstants.getProfileUri;

    this.service.get(requestUrl).subscribe((res: any) => {
      try {
        if (res) {
          this.saveApigeeCustomerInfo(res.userDetails);

          res.userDetails.username = res.userDetails.userName;

          this.callRAMSellerServNumber(res.userDetails);

          /* Do not change code above this line */
          if (res.userDetails.groups.length > 0) {
            sessionStorage.setItem('roles', JSON.stringify(res.userDetails.groups));

            const isAuth = this.setApigeeRoleAuthentication(res.userDetails);
            if (isAuth) {
              this.handleAppRedirect();
            }
            this.isAuthenticated.next(true);
            // sessionStorage.setItem("access_token",res.token.accessToken);
            // sessionStorage.setItem("id_token",res.token.idToken);
            return true;
          } else {
            res.userDetails.roleMatch = false;
            this.saveApigeeCustomerInfo(res.userDetails);
            //TODO Need to add the messaging for no role match
            this.router.navigate(['/mainMenu']);
            return false;
          }
        }
      } catch {
        // A thrown error here is NOT routed to the subscribe error callback below, so it would otherwise vanish silently and leave the page blank forever
        this.router.navigate(['/mainMenu']);
      }
    }, () => {
      this.redirectToCDXRedirectPath();
      return false;
    });
    return false;
  }

  public redirectToCDXRedirectPath() {
    window.location.href = 'https://' + this.hostname + UrlConstants.login;
  }

  /*  Navigate to the url page with extras,
     in some cases URL is coming as '/', Ex. when user click logout */
  public handleAppRedirect() {
    if (this.service.redirectUrl) {
      this.router.navigateByUrl(this.service.redirectUrl);
    }
  }

  /* Set Role Authentication in sessionStorage for APIGEE */
  public setApigeeRoleAuthentication(userDataResponse) {

    if (userDataResponse.groups.length === 0) {
      return false;
    }
    // check internal user or not
    if (!userDataResponse.isInternalUser) {
      this.isUserExternal = true;
    } else {
      this.isUserExternal = false;
    }

    sessionStorage.setItem('isAdmin', 'false');
    sessionStorage.setItem('isDeveloper', 'false');
    sessionStorage.setItem('isRMInternal_View', 'false');
    sessionStorage.setItem('isRMInternal_Update', 'false');
    sessionStorage.setItem('isRMExternal_Servicing_View', 'false');
    sessionStorage.setItem('isRMExternal_Servicing_Update', 'false');
    sessionStorage.setItem('isRMExternal_Delivery_View', 'false');
    sessionStorage.setItem('isRMExternal_Delivery_Update', 'false');

    /** getting all the roles from roles.json **/
    this.roleService.getRoles().subscribe((data: any) => {
      try {
        const matchRoles = this.processSessionAndRoles(data, userDataResponse);
        this.validateMatchingRoles(matchRoles, userDataResponse);
      } catch {
        // A thrown error here is NOT routed to the subscribe error callback below, so it would otherwise vanish silently and leave the page blank forever
        this.router.navigate(['/mainMenu']);
      }
    }, () => {
      // Without this, a failed/slow roles.json load silently stalls the auth chain and leaves the page blank forever
      this.router.navigate(['/mainMenu']);
    });



  }

  isDeliveryuser()
  {

    const isAdmin = JSON.parse(sessionStorage.getItem('isAdmin'));
    const isDeveloper = JSON.parse(sessionStorage.getItem('isDeveloper'));
    const rmIntView = JSON.parse(sessionStorage.getItem('isRMInternal_View'));
    const rmIntUpdate = JSON.parse(sessionStorage.getItem('isRMInternal_Update'));
    const rmExtDelView = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_View'));
    const rmExtDelUpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_Update'));


    if (rmExtDelView || rmExtDelUpdate || isAdmin
      || isDeveloper || rmIntView ||  rmIntUpdate)
    {
      return true;
    }
    return false;
  }


  isServicingUser()
  {

    const isAdmin = JSON.parse(sessionStorage.getItem('isAdmin'));
    const isDeveloper = JSON.parse(sessionStorage.getItem('isDeveloper'));
    const rmIntView = JSON.parse(sessionStorage.getItem('isRMInternal_View'));
    const rmIntUpdate = JSON.parse(sessionStorage.getItem('isRMInternal_Update'));
    const rmExtSerView = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_View'));
    const rmExtSerpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_Update'));


    if (rmExtSerView || rmExtSerpdate || isAdmin
      || isDeveloper || rmIntView ||  rmIntUpdate)
    {
      return true;
    }
    return false;
  }


  public getValueCache() {
    if (this.hostname === 'localhost') {
      const mockSysAttrMap = {
        sysAttrMap: {
          isSystemBannerMsgAvailable: 'false',
          isDeliveryServicingBannerMsgAvailable: 'false',
          isServicingBannerMsgAvailable: 'false',
          isDeliveryBannerMsgAvailable: 'false',
          systemAvailabilityMessage: '',
          deliveryServicingBannerMsg: '',
          servicingBannerMsg: '',
          deliveryBannerMsg: '',
          RMAvailabilityIndicator: 'true',
          systemAvailabilityIndicator: 'true',
          isServicingSysAvailable: 'true',
          isDeliverySysAvailable: 'true',
          isExternalAccessAvailable: 'true'
        }
      };
      return of(mockSysAttrMap);
    }
    return this.service.getValueCache();
  }

  public setBannerMsgVal(userDataResponse, keyMap)
  {
    const flag = true;
    if (!userDataResponse.isInternalUser) {
      this.isUserExternal = true;
    } else {
      this.isUserExternal = false;
    }



    //banner flags
    const isSystemBannerAvailable = keyMap[Constants.IS_SYSTEM_BAN_MSG_AVAIL];
    const isDeliveryServicingMsgAvaible = keyMap[Constants.IS_DELIVERY_SERVICING_BAN_MSG_AVAIL];
    const isServincingBannerAvailable = keyMap[Constants.IS_SERVICING_BAN_MSG_AVAIL];
    const isDeliveryBannerAvailable = keyMap[Constants.IS_DELIVERY_BAN_MSG_AVAIL];

    //banner data
    const systemAvailMsg = keyMap[Constants.SYSTEM_MESSAGE];
    const deliveryServicingMsg = keyMap[Constants.RM_MonthEndProcIndicatorMsg];
    const servicingBannerMsg = keyMap[Constants.SERVICING_BAN_MSG];
    const deliveryBannerMsg = keyMap[Constants.DELIVERY_BAN_MSG];


    /*
           * if system banner flag is set to true diplay the system banner
           * message
           */
    if (isSystemBannerAvailable != null && isSystemBannerAvailable === 'true') {
      sessionStorage.setItem(Constants.SYSTEM_MESSAGE, systemAvailMsg);
    }
    if ((this.isDeliveryuser() || this.isServicingUser())
          && isDeliveryServicingMsgAvaible != null
          && isDeliveryServicingMsgAvaible === 'true') {
      sessionStorage.setItem(Constants.RM_MonthEndProcIndicatorMsg, deliveryServicingMsg);

    }
    if ( (this.isServicingUser()) && isServincingBannerAvailable != null
          && isServincingBannerAvailable === 'true') {
      sessionStorage.setItem(Constants.SERVICING_BAN_MSG, servicingBannerMsg);
    }
    if ( (this.isDeliveryuser()) && isDeliveryBannerAvailable != null
          && isDeliveryBannerAvailable === 'true') {
      sessionStorage.setItem(Constants.DELIVERY_BAN_MSG, deliveryBannerMsg);
    }

    //Adding Availability indicators of Developer section

    sessionStorage.setItem('ServicingSystemIndicator', keyMap[Constants.RM_ServicingSysAvailable]);
    sessionStorage.setItem('DeliverySystemIndicator', keyMap[Constants.RM_DeliverySysAvailable]);
    sessionStorage.setItem('RMSystemIndicator', keyMap[Constants.RM_Indicator]);
    sessionStorage.setItem('SystemIndicator', keyMap[Constants.SYSTEM_INDICATOR]);

    const externalIndicator = keyMap[Constants.ExternalSysAvailable];

    if (this.isUserExternal && externalIndicator === 'false')
    {
      // this.redirectToCDXRedirectPath();
      this.router.navigate(['/error'], {queryParams: {externalFlag:'false'}});
      return false;
    }

    return flag;

  }


  /** Setting session roles */
  public processSessionAndRoles(roleData: any, userDataResponse : any) : boolean {

    let matchRoles = false;
    for (let userRole of userDataResponse.groups) {

      userRole = userRole.replace(/\b(?:DEVL|TEST|ACPT|PROD)\b/gi, 'ENVIRONMENT');
      const filterRoleData = roleData.roles.find(ob => ob[this.role] === userRole);

      if (filterRoleData != null) {
        matchRoles = true;
        sessionStorage.setItem('userID', userRole.userName);
        /** Check if the user is internal roles or external **/
        if (this.isUserExternal) {

          /** For external users */
          if (filterRoleData.roleType === this.RM_EXTERNAL_DELIVERY_VIEW) {

            if ((userRole.includes('EBOUTIQ_DeliveryExternalView') > -1)) {
              sessionStorage.setItem('isRMExternal_Delivery_View', true);
            }
          }

          if (filterRoleData.roleType === this.RM_EXTERNAL_DELIVERY_UPDATE) {

            if ((userRole.includes('EBOUTIQ_DeliveryExternalUpdate') > -1) ) {
              sessionStorage.setItem('isRMExternal_Delivery_Update', true);
            }
          }

          if (filterRoleData.roleType === this.RM_EXTERNAL_SERVICING_UPDATE) {

            if ((userRole.includes('EBOUTIQ_ServicingExternalUpdate') > -1)) {
              sessionStorage.setItem('isRMExternal_Servicing_Update', true);
            }
          }
          if (filterRoleData.roleType === this.RM_EXTERNAL_SERVICING_VIEW) {

            if ((userRole.includes('EBOUTIQ_ServicingExternalView') > -1)) {
              sessionStorage.setItem('isRMExternal_Servicing_View', true);
            }
          }


        } else {

          /** For Internal users**/
          if (filterRoleData.allow && filterRoleData.roleType === this.DEVELOPER_UPDATE) {

            if ((userRole.lastIndexOf('EBOUTIQUE-Developer') > -1 || userRole.lastIndexOf('EBOUTIQUE-AWS-Developer') > -1) && (userRole.indexOf('SG') > -1)) {
              sessionStorage.setItem('isDeveloper', true);
            }
          }
          if (filterRoleData.allow && filterRoleData.roleType === this.ADMIN_UPDATE) {
            if ((userRole.lastIndexOf('EBOUTIQUE-Admin') > -1 || userRole.lastIndexOf('EBOUTIQUE-AWS-Admin') > -1) && (userRole.indexOf('SG') > -1)) {
              sessionStorage.setItem('isAdmin', true);
            }
          }
          if (filterRoleData.allow && filterRoleData.roleType === this.RM_INTERNAL_VIEW) {

            if ((userRole.lastIndexOf('EBOUTIQUE-RMInternalView') > -1 || userRole.lastIndexOf('EBOUTIQUE-AWS-RMInternalView') > -1) && (userRole.indexOf('SG') > -1)) {
              sessionStorage.setItem('isRMInternal_View', true);
            }
          }
          if (filterRoleData.allow && filterRoleData.roleType === this.RM_INTERNAL_UPDATE) {

            if ((userRole.lastIndexOf('EBOUTIQUE-RMInternal') > -1 || userRole.lastIndexOf('EBOUTIQUE-AWS-RMInternal') > -1) && (userRole.indexOf('SG') > -1)) {
              sessionStorage.setItem('isRMInternal_Update', true);
            }
          }

        }

      }

    }
    return matchRoles;
  }

  public validateMatchingRoles( matchingRoles:any, userDataResponse :any)
  {
    this.getValueCache().subscribe(data=>{
      try {
        const keyMap = data.sysAttrMap;
        let flagVal = true;
        flagVal = this.setBannerMsgVal(userDataResponse, keyMap);

        if (flagVal) {
          if (!matchingRoles) {
            //TODO Need to add the messaging for no role match
            this.router.navigate(['/mainMenu']);
            return false;
          } else {
            userDataResponse.roleMatch = true;
            this.saveApigeeCustomerInfo(userDataResponse);

            // check if the user is delivery external update user
            if (sessionStorage.getItem('isRMExternal_Delivery_Update') === 'true') {
              const userId = sessionStorage.getItem('userID');

              const userContactWrapper = {
                userid: userId
              };

              // get the conctact information from database
              this.service.getUserContactInfo(userContactWrapper).subscribe(data => {
                if (data == null) {
                  this.router.navigateByUrl('/contactInfo');
                } else {
                  // If the contact information is already available then redirect to mainmenu
                  this.router.navigateByUrl(this.service.redirectUrl);
                }
              },
              () => {
              });
            } else {
              // Not a delivery external update user so redirect to mainmenu
              this.router.navigate(['/mainMenu']);
            }

            return true;
          }
        }
      } catch {
        // A thrown error here is NOT routed to the subscribe error callback below, so it would otherwise vanish silently and leave the page blank forever
        this.router.navigate(['/mainMenu']);
      }
    }, ()=>{
      // Without a fallback navigation here, a failed getSysAttrMap call leaves the page blank forever
      this.router.navigate(['/mainMenu']);
    });



  }

  /* Saving customer details returned as part of APIGEE, sessionId
      is saved as part of interceptor */
  public saveApigeeCustomerInfo(res) {
    this.isAuthenticated.next(true);
    sessionStorage.setItem('userName', res.firstName + ' ' + res.lastName);
    sessionStorage.setItem('userID', res.uid);
    this.authService.saveApigeeCustomerData(res);
    this.authService.setAuthFlag();
  }

  /** Request Seller and Serviver from RAMAPI */
  public callRAMSellerServNumber = (user : any) => {
    // Skip RAM API call for localhost - developer/admin users have no seller/servicer associations
    if (this.hostname === 'localhost') {
      sessionStorage.setItem('sellerNumbers', JSON.stringify([]));
      sessionStorage.setItem('servicerNumbers', JSON.stringify([]));
      sessionStorage.setItem('authServicerNumbers', JSON.stringify([]));
      return;
    }
    const dataInput = { userProfile : user};
    this.service.callRAMSellerServAPI(dataInput).subscribe(
      (data: any) => {

        if (data != null) {
          const sellerNumbers = [];
          const sellNumArr = [];
          const authServicerNumbers = [];
          const authServicerNumbersArr = [];
          const servicerNumbers = [];
          const servicerNumbersArr = [];

          /** setting seller list*/
          if (Array.isArray(data.sellerList)) {
            for (const sell of data.sellerList) {
              sellerNumbers.push({ label: sell, value: sell });
              sellNumArr.push(sell);
            }
          }
          /** setting servicer list (auterized) i.e. all servicers and subservicers*/
          if (Array.isArray(data.authorizedServicers)) {
            for (const ser of data.authorizedServicers) {
              authServicerNumbers.push({ label: ser, value: ser });
              authServicerNumbersArr.push(ser);
            }
          }

          /** setting servicer list */
          if (Array.isArray(data.servicerList)) {
            for (const ser of data.servicerList) {
              servicerNumbers.push({ label: ser, value: ser });
              servicerNumbersArr.push(ser);
            }
          }

          /*
          * determine if the user is a Wells Fargo user... this flag is used
          * to determine if the report 38 will be displayed in the monthly
          * report drop down or not.
          */
          let isWellsFargoUser = false;
          authServicerNumbersArr.forEach(servrNum => {
            if (servrNum.toString().startsWith('16570')) {
              isWellsFargoUser = true;
            }
          });


          sessionStorage.setItem('sellerList', JSON.stringify(sellerNumbers));
          sessionStorage.setItem('sellerNumbersArr', JSON.stringify(sellNumArr));
          sessionStorage.setItem('authServrList', JSON.stringify(authServicerNumbers));
          sessionStorage.setItem('authServicerNumbersArr', JSON.stringify(authServicerNumbersArr));
          sessionStorage.setItem('servicerList', JSON.stringify(servicerNumbers));
          sessionStorage.setItem('servicerNumbersArr', JSON.stringify(servicerNumbersArr));
          sessionStorage.setItem('isWellsFargoUser', isWellsFargoUser);
        }
      });
  };
}
